/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnSubLnbDetailRequest model module.
 * @module model/SystemControllerDtoMnSubLnbDetailRequest
 * @version 1.0
 */
class SystemControllerDtoMnSubLnbDetailRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnSubLnbDetailRequest</code>.
     * @alias module:model/SystemControllerDtoMnSubLnbDetailRequest
     * @param subNo {Number} 
     */
    constructor(subNo) { 
        
        SystemControllerDtoMnSubLnbDetailRequest.initialize(this, subNo);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, subNo) { 
        obj['subNo'] = subNo;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnSubLnbDetailRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnSubLnbDetailRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnSubLnbDetailRequest} The populated <code>SystemControllerDtoMnSubLnbDetailRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnSubLnbDetailRequest();

            if (data.hasOwnProperty('subNo')) {
                obj['subNo'] = ApiClient.convertToType(data['subNo'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnSubLnbDetailRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnSubLnbDetailRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnSubLnbDetailRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }

        return true;
    }


}

SystemControllerDtoMnSubLnbDetailRequest.RequiredProperties = ["subNo"];

/**
 * @member {Number} subNo
 */
SystemControllerDtoMnSubLnbDetailRequest.prototype['subNo'] = undefined;






export default SystemControllerDtoMnSubLnbDetailRequest;

